import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import MainPage from './Components/MainPage';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <MainPage/>
  
  <BrowserRouter>
    <Routes>
      <Route path='/' element={<MainPage/>}/>
    </Routes>
  </BrowserRouter>
  
);

